import { useState, useContext } from "react";
import { GlobalContext } from "../../Context/GlobalContext";

const useUdhari = () => {
 const { api, anlookApi, userID } = useContext(GlobalContext);


  const [loading, setLoading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [billData, setBillData] = useState(null);

  // ================= GET CUSTOMERS =================
  const getCustomers = async () => {
    try {
      setLoading(true);

      const res = await api.post(
        "/Order/v1.0/Credit/getAllOrderCustomerAccountDetails",
        { userid: userID },
      );

      if (res.data?.responseCode === "00") {
        setCustomers(res.data.response || []);
      } else {
        setCustomers([]);
      }
      return res;
    } catch (err) {
      console.error("Get Customers Error:", err);
      setCustomers([]);
    } finally {
      setLoading(false);
    }
  };

  // ================= ADD CUSTOMER =================
  const addCustomer = async (payload) => {
    try {
      setLoading(true);

      const res = await api.post(
        "/Order/v1.0/Credit/addOrderCustomerAccountDetails",
        payload
      );

      return res.data;
    } catch (err) {
      console.error("Add Customer Error:", err);
      return null;
    } finally {
      setLoading(false);
    }
  };

  // ================= UPDATE CUSTOMER =================
  const updateCustomer = async (payload) => {
    try {
      setLoading(true);

      const res = await api.post(
        "/Order/v1.0/Credit/updateOrderCustomerAccountDetails",
        payload
      );

      return res.data;
    } catch (err) {
      console.error("Update Error:", err);
      return null;
    } finally {
      setLoading(false);
    }
  };

  // ================= DELETE CUSTOMER =================
  const deleteCustomer = async (payload) => {
    try {
      setLoading(true);

      const res = await api.post(
        "/Order/v1.0/Credit/deleteOrderCustomerAccountDetails",
        payload
      );

      return res.data;
    } catch (err) {
      console.error("Delete Error:", err);
      return null;
    } finally {
      setLoading(false);
    }
  };

  // ================= GENERATE BILL =================
  const generateBill = async (payload) => {
    try {
      setLoading(true);

      const res = await api.post(
        "/Order/v2.0/generateCreditBill",
        payload
      );

      if (res.data?.responseCode === "00") {
        setBillData(res.data.response);
      }

      return res.data;
    } catch (err) {
      console.error("Generate Bill Error:", err);
      return null;
    } finally {
      setLoading(false);
    }
  };

  // ================= SETTLE BILL =================
  const settleBill = async (payload) => {
    try {
      setLoading(true);

      const res = await api.post(
        "/Order/v1.0/settleCreditBill",
        payload
      );

      return res.data;
    } catch (err) {
      console.error("Settle Bill Error:", err);
      return null;
    } finally {
      setLoading(false);
    }
  };

  // ================= SAVE INVOICE =================
 const saveInvoice = async (payload) => {
  try {
    setLoading(true);

    console.log("SAVE INVOICE SERVICE PAYLOAD:", payload);

    const res = await api.post(
      "/Order/Invoice/v1.0/saveInvoice",
      payload
    );

    return res.data;
  } catch (err) {
    console.error(
      "Save Invoice Error:",
      err?.response?.data || err,
    );

    return {
      responseCode: "01",
      responseMessage:
        err?.response?.data?.responseMessage ||
        err?.response?.data?.message ||
        err?.message ||
        "Invoice save failed",
      response: null,
    };
  } finally {
    setLoading(false);
  }
};

  // ================= GENERATE INVOICE IMAGE =================
const generateInvoiceImage = async (payload) => {
  try {
    setLoading(true);

    if (!anlookApi) {
      throw new Error("Anlook API instance missing");
    }

    const res = await anlookApi.post("/v1/generateInvoiceImagev2.php", payload);

    if (
      String(res?.data?.status) === "0" ||
      res?.data?.responseCode === "00" ||
      res?.data?.success === true
    ) {
      return res.data;
    }

    throw new Error(
      res?.data?.message ||
        res?.data?.responseMessage ||
        "Invoice image generation failed",
    );
  } catch (error) {
    console.error(
      "Generate Invoice Image Error:",
      error?.response?.data || error,
    );

    return {
      status: "1",
      responseCode: "01",
      message:
        error?.response?.data?.message ||
        error?.response?.data?.responseMessage ||
        error?.message ||
        "Invoice image generation failed",
    };
  } finally {
    setLoading(false);
  }
};

const getOrderInvoices = async (payload) => {
  try {
    setLoading(true);

    const res = await api.post(
      "/Order/v1.0/getOrderInvoices",
      payload
    );

    if (res.data?.responseCode === "00") {
      setInvoices(res.data.response || []);
    } else {
      setInvoices([]);
    }

    return res.data;
  } catch (err) {
    console.error("Get Order Invoices Error:", err);

    setInvoices([]);

    return null;
  } finally {
    setLoading(false);
  }
};

const deleteInvoice = async (payload) => {
  try {
    setLoading(true);

    const res = await api.post(
      "/Order/v1.0/deleteInvoice",
      payload
    );

    return res.data;
  } catch (err) {
    console.error("Delete Invoice Error:", err);
    return null;
  } finally {
    setLoading(false);
  }
};

const updateInvoiceStatus = async (payload) => {
  try {
    setLoading(true);

    const res = await api.post(
      "/Order/v1.0/updateInvoiceStatus",
      payload
    );

    return res.data;
  } catch (err) {
    console.error("Update Invoice Status Error:", err);
    return null;
  } finally {
    setLoading(false);
  }
};

  return {
    loading,
    customers,
    invoices,
    billData,

    getCustomers,
    addCustomer,
    updateCustomer,
    deleteCustomer,
    generateBill,
    settleBill,
    saveInvoice,
    generateInvoiceImage, 
    getOrderInvoices,
    deleteInvoice,
    updateInvoiceStatus,
  };
};

export default useUdhari;